import {BindingConfig} from '@mintdata/mint-kit/api/properties/BindingConfig';
import {PropertyCategory} from '@mintdata/mint-kit/api/properties/PropertyCategory';
import {IPropertyTypeConfig} from '@mintdata/mint-kit/api/properties/PropertyTypeConfig';
import {PropPath} from '@mintdata/mint-kit/api/properties/PropPath';
import {IValue} from '@mintdata/mint-kit/api/types/Value';

export type PropName = string;
export type PropertyTypeConstructor<T> = {
    new(...args):T;
    coerce?(from:IValue):T | null;
    default?:() => T;
};
export type ChangePropertyCallback<T> = (rootPropName:PropName, rootPropValue:any, propPath:PropPath, propValue:T) => boolean;

export interface IPropertySpec<T>
{
    readonly title:string;
    readonly tip:string;
    readonly category?:PropertyCategory;
    readonly isRequired:boolean;
    readonly isIgnoredByRepeater?:boolean;
    readonly typeConfig:IPropertyTypeConfig<T>;
    readonly typeCtor:PropertyTypeConstructor<T>;
    readonly binding?:BindingConfig;
    readonly isManualConfirmation?:boolean;
    readonly keepValueAfterBindingRemoving?:boolean;
}

export class PropertySpec<T> implements IPropertySpec<T>
{
    constructor(public readonly name:PropName,
                public readonly title:string,
                public readonly tip:string,
                public readonly category:PropertyCategory = PropertyCategory.Common,
                public readonly isDisabled:boolean,
                public readonly isRequired:boolean,
                public readonly isIgnoredByRepeater:boolean = false,
                public readonly typeConfig:IPropertyTypeConfig<T>,
                public readonly typeCtor:PropertyTypeConstructor<T>,
                public readonly binding:BindingConfig = BindingConfig.with('@*'),
                public readonly isManualConfirmation:boolean = false,
                public readonly keepValueAfterBindingRemoving:boolean = true)
    {
    }
}
